<template>
  <NuxtLink :to="ruta('/blog/' + entrada.Slug)" class="mt-entrada">
    <div class="mt-entrada__imagen">
      <img v-if="entrada.Imagen" :src="imagenIDtoSRC(entrada.Imagen)" :alt="''" loading="lazy" />
      <v-icon v-else size="40">mdi-text-box-outline</v-icon>
    </div>
    <div class="mt-entrada__cuerpo">
      <span v-if="entrada.Categorias?.length" class="mt-entrada__categoria">{{ entrada.Categorias[0] }}</span>
      <h3 class="mt-entrada__titulo">{{ entrada.Titulo }}</h3>
      <p v-if="entrada.Extracto" class="mt-entrada__extracto">{{ entrada.Extracto }}</p>
      <span class="mt-entrada__meta">
        {{ fechaEntrada(entrada.Fecha) }}<template v-if="entrada.Contenido"> · {{ minutosLectura(entrada.Contenido) }} min de lectura</template>
      </span>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { useUtils } from '#imports'
import { fechaEntrada, minutosLectura, type EntradaBlog } from '../../composables/useMinotariaBlog'

defineProps<{ entrada: EntradaBlog }>()
const { imagenIDtoSRC } = useUtils()
const route = useRouter().currentRoute
const ruta = (p: string) => (route.value.params.lang ? `/${route.value.params.lang}` : '') + p
</script>
